import React from "react";

import "./ProductsContainer.scss";

const ProductsContainer = props => {
  return <div className="ProductsContainer">{props.children}</div>;
};

export default ProductsContainer;
